// PHPから渡されたグローバル変数の型定義
declare const entryFormData: {
  eventTitle: string;
};

// hiddenフィールドにイベントタイトルをセットする関数
const setEventTitle = (): void => {
  // entryFormData が未定義（エントリーフォームページ以外）の場合は何もしない
  if (typeof entryFormData === "undefined") return;

  // イベントタイトルが空の場合も何もしない
  if (!entryFormData.eventTitle) return;

  // CF7が生成した input[name="event-title"] を取得
  const hiddenField = document.querySelector<HTMLInputElement>(
    'input[name="event-title"]',
  );

  // フィールドが存在すれば値をセット
  if (hiddenField) {
    hiddenField.value = entryFormData.eventTitle;
  }
};

// 他のモジュールと同様に初期化関数としてエクスポート
export const initEntryForm = (): void => {
  setEventTitle();
};
